// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__sD32m","ranges":"BmiRanges_ranges__JzYxP"};